// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a0c4a158","42":"d5042ae2","992":"6ebb4e7f"}[chunkId] + ".chunk.js";
};